import React from 'react';

interface FloatingText {
  id: string;
  text: string;
  x: number;
  y: number;
  color: string;
  timestamp: number;
}

interface FloatingNotificationProps {
  notification: FloatingText;
}

const FloatingNotification: React.FC<FloatingNotificationProps> = ({ notification }) => {
  const timeSinceCreation = Date.now() - notification.timestamp;
  
  // Ensure we don't render invalid notifications
  if (timeSinceCreation >= 1000 || timeSinceCreation < 0) return null;
  
  const opacity = Math.max(0, Math.min(1, 1 - (timeSinceCreation / 1000)));
  const translateY = -40 * (timeSinceCreation / 1000);

  return (
    <div 
      className="floating-notification"
      style={{
        left: notification.x,
        top: notification.y,
        transform: `translateY(${translateY}px)`,
        opacity,
        color: notification.color,
        willChange: 'transform, opacity'
      }}
    >
      {notification.text}
    </div>
  );
};

export default React.memo(FloatingNotification);

